/**
 * Returns the full URL for a Supabase Edge Function.
 *
 * Lovable hosting does NOT process `public/_redirects`, so the `/api/*`
 * proxy pattern doesn't work. We always call the function directly.
 */
export function edgeFunctionUrl(functionName: string): string {
  return `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/${functionName}`;
}
